import Vue from 'vue'
import Vuex from 'vuex'
import { getAction, postAction } from '@/api/manage'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
  },
  state: {
    currentHotelId: '',
    currentRoomTypeId: '',
    currentLanguage: 'zh',
    conversationFlagList: [], // 未读消息列表
    productChooseList: [], // 已选择的产品列表
    productChooseShow: false,
    site: null,
  },
  mutations: {
    updateConversationFlagList(st, data) {
      st.conversationFlagList = data
    },
    updateHotelId(st, data) {
      st.currentHotelId = data
    },
    updateRoomTypeId(st, data) {
      st.currentRoomTypeId = data
    },
    updateKeyword(st, data) {
      st.currentKeyword = data
    },
    updateLanguage(st, data) {
      st.currentLanguage = data
    },
    setProductList: (state, list) => {
      state.productChooseList = list
    },
    pushProductList: (state, product) => {
      state.productChooseList.push(product)
    },
    updateUserIdInProductList: (state, newUserId) => {
      state.productChooseList.forEach(product => {
        product.userId = newUserId;
      });
    },
    setProductChooseShow(st, data) {
      st.productChooseShow = data
    },
    updateSite(st, data) {
      st.site = data
    },
  },
  actions: {
    // 订单支付
    createPayment({ commit }, data) {
      // orderType ： 默认：GROUP_ORDER，单独预定时：酒店的传 HOTEL_ORDER 商品活动的 传 PRODUCT_ORDER
      // groupId ： 酒店的传酒店的订单ID 商品活动传商品活动的订单ID
      const { groupId, platForm, hotelId, orderType } = data
      const url = window.location.protocol + '//' + window.location.host


      let userAgent = navigator.userAgent.toLowerCase();

      // 使用正则表达式判断设备类型
      let device = /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/;
      let sufix = '';
      if(device.test(userAgent)){
        // 跳转到移动端页面
        sufix = "h5/";
      }else{
        // 跳转到桌面端页面
        sufix = "pc/";
      }


      const cancelUrl = `${url}/${sufix}payfail?id=${groupId}&platForm=${platForm}&hotelId=${hotelId}&orderType=${orderType}`
      const successUrl = `${url}/${sufix}paysuccess`

      let postData = {
        cancelUrl,
        groupId, // 组合订单Id
        hotelId,
        platForm, // Stripe , Paypay
        successUrl,
      }

      if (orderType) {
        postData.orderType = orderType
      }

      postAction(`/user/api/createPayment`, postData).then((response) => {
        console.log('---- 支付 ----', response)
        if (response.success) {
          // 跳转支付
          window.location.href = response.result
        } else {
          // 支付失败
        }
      })
    },
    // 续房支付
    createExtendStayPayment({ commit }, data) {
      const { orderId, platForm } = data
      const url = window.location.protocol + '//' + window.location.host


      let userAgent = navigator.userAgent.toLowerCase();

      // 使用正则表达式判断设备类型
      let device = /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/;
      let sufix = '';
      if(device.test(userAgent)){
        // 跳转到移动端页面
        sufix = "h5/";
      }else{
        // 跳转到桌面端页面
        sufix = "pc/";
      }


      const cancelUrl = `${url}/${sufix}payfail?id=${orderId}&platForm=${platForm}&type=stayExtend`
      const successUrl = `${url}/${sufix}paysuccess`
      postAction(`/user/api/createExtendStayPayment`, {
        cancelUrl,
        orderId,
        platForm, // Stripe , Paypay
        successUrl,
      }).then((response) => {
        console.log('---- 支付 ----', response)
        if (response.success) {
          // 跳转支付
          window.location.href = response.result
        } else {
          // 支付失败
        }
      })
    },
  },
})
